// viva_ui/src/Reports/AttemptDropdown.js
 
import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
 
const AttemptDropdown = ({
  value,
  onChange,
  minWidth = 180,
  latestLabel = 'Latest Attempt',
}) => {
  const options = [
    { value: 'all', label: 'All Attempts' },
    { value: 'latest', label: latestLabel },
  ];

  return (
    <FormControl size="small" sx={{ minWidth }}>
      <Select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        displayEmpty
        sx={{
          height: '40px',
          fontSize: '0.875rem',
          background: 'white',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
 
export default AttemptDropdown;
 
